'use client';

import { Suspense } from 'react';

import { NavigationProgress as CoreNavigationProgress } from '../../../node_modules/@eliadmin/core/src/components/providers/navigation-progress';

import type { ComponentProps } from 'react';

export function NavigationProgress(props: ComponentProps<typeof CoreNavigationProgress>) {
  return (
    <Suspense fallback={null}>
      <CoreNavigationProgress {...props} />
    </Suspense>
  );
}
